import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Map,
  Marker,
  InfoWindow,
  DirectionsRenderer,
  TrafficLayer,
} from 'components/maps';
import SessionStore from 'stores/SessionStore';
import USER_TYPES from 'constants/UserTypes';

const isShipper = () => {
  const { _type } = SessionStore.getUser() || {};
  return _type?.toLowerCase() === USER_TYPES.SHIPPER;
};

const MapView = ({
  initCenter,
  initZoom,
  height,
  markers,
  fitMarkers,
  showTraffic,
  directions,
}) => {
  const [openMarkerId, setOpenMarkerId] = useState(null);

  const center = { lat: initCenter[0], lng: initCenter[1] };
  const fitBoundsTo = fitMarkers ? markers.map((m) => m.position) : undefined;

  const handleMarkerClick = (id) => {
    if (isShipper()) return;
    setOpenMarkerId(id);
  };

  return (
    <Map
      height={height}
      defaultZoom={initZoom}
      defaultCenter={center}
      fitBoundsTo={fitBoundsTo}
      options={{
        zoomControlOptions: {
          position: google.maps.ControlPosition.RIGHT_TOP,
        },
        streetViewControlOptions: {
          position: google.maps.ControlPosition.RIGHT_TOP,
        },
      }}
    >
      {markers.map((m) => (
        <React.Fragment key={m.id}>
          <Marker
            icon={m.icon}
            position={m.position}
            onClick={() => handleMarkerClick(m.id)}
          />
          {openMarkerId === m.id && m.info && (
            <InfoWindow
              position={m.position}
              onClose={() => setOpenMarkerId(null)}
            >
              <div dangerouslySetInnerHTML={{ __html: m.info }} />
            </InfoWindow>
          )}
        </React.Fragment>
      ))}
      {showTraffic && <TrafficLayer />}
      {directions && <DirectionsRenderer directions={directions} />}
    </Map>
  );
};

MapView.propTypes = {
  id: PropTypes.string,
  initCenter: PropTypes.array,
  initZoom: PropTypes.number,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  directions: PropTypes.object,
  markers: PropTypes.array,
  fitMarkers: PropTypes.bool,
  showTraffic: PropTypes.bool,
};

MapView.defaultProps = {
  initCenter: [34.0383912, -118.2874809],
  initZoom: 11,
  height: '100%',
  directions: null,
  markers: [],
  fitMarkers: false,
  showTraffic: false,
};

export default MapView;
